module.exports = __webpack_public_path__ + "static/media/1012694.da41efe9.jpg";